import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full bg-[#1B2A4A] text-white" data-id="element-167">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-169">
          <QuoteIcon className="w-16 h-16 text-[#C9A84C] opacity-20 absolute -top-4 -left-2" data-id="element-170" />

          <div className="relative z-10 text-center" data-id="element-171">
            <p className="text-2xl sm:text-3xl font-serif leading-relaxed mb-6" data-id="element-172">
              Imagina despertar el día de tu entrevista con la tranquilidad de
              quien ya sabe lo que va a pasar.
            </p>

            <p className="text-xl text-gray-200 mb-6" data-id="element-173">
              En solo 7 días aplicando nuestro Método de Anclaje, verás cómo las
              fechas y nombres que antes te confundían se vuelven automáticos en
              tu mente.
            </p>

            <p className="text-2xl font-bold text-[#C9A84C]" data-id="element-174">
              No estarás adivinando; estarás respondiendo.
            </p>
          </div>

          <QuoteIcon className="w-16 h-16 text-[#C9A84C] opacity-20 absolute -bottom-4 -right-2 rotate-180" data-id="element-175" />
        </motion.div>
      </div>
    </section>;
}